import { SparklesIcon } from '@heroicons/react/16/solid'
import React from 'react'
import { useTranslation } from 'react-i18next'
import ReactMarkdown from 'react-markdown'
import { Heading } from '../../../../components/ui/Heading'

type JoyrideMessageProps = {
  title?: string
  description?: string
  detailsLink?: string
}

export default function JoyrideMessage({
  title,
  description,
  detailsLink
}: JoyrideMessageProps) {
  const { t } = useTranslation()
  return (
    <React.Fragment>
      <div className='flex w-full items-center'>
        <div className='flex flex-row items-center text-base font-semibold text-gray-900'>
          <SparklesIcon className='mr-4 size-4 text-aivyBlue' />
          <Heading level={3}>{t('discover.assistant.assistant')}</Heading>
        </div>
      </div>
      <div className='mt-4 rounded-lg border border-lightGrey bg-[#EBEFFD66] p-4'>
        {title && (
          <Heading level={5} className='text-left'>
            {title}
          </Heading>
        )}
        {description && (
          <div className='mt-2 w-full'>
            <ReactMarkdown
              components={{
                p: ({ children }) => (
                  <p className='text-left text-sm font-normal text-darkBlack'>
                    {children}
                  </p>
                )
              }}
            >
              {description}
            </ReactMarkdown>
          </div>
        )}
        {detailsLink && (
          <div className='mt-4 flex items-center'>
            <a
              href={detailsLink}
              target='_blank'
              rel='noopener noreferrer'
              className='flex items-center gap-1 text-xs text-gray-500 hover:text-gray-700'
            >
              <svg className='size-3' fill='currentColor' viewBox='0 0 20 20'>
                <path
                  fillRule='evenodd'
                  d='M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z'
                  clipRule='evenodd'
                />
              </svg>
              Mehr erfahren
            </a>
          </div>
        )}
      </div>
    </React.Fragment>
  )
}
